import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  type CouponDiscountType,
  type CouponStatusFilter,
  getCoupons,
  type SortDirection,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const COUPONS_QUERY_KEY = "COUPONS";

export type CouponsListParams = {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortDirection?: SortDirection;
  code?: string;
  status?: CouponStatusFilter;
  discountType?: CouponDiscountType;
  expirationDateFrom?: string;
};

export const couponsKeys = {
  all: [COUPONS_QUERY_KEY],
  byParams: (params: CouponsListParams) => [...couponsKeys.all, params],
};

export const useCouponsQuery = (params: CouponsListParams = {}) =>
  useQuery({
    queryKey: couponsKeys.byParams(params),
    queryFn: processResponseWithApiProblemDetails(() =>
      getCoupons(
        params.code,
        params.status,
        params.discountType,
        params.expirationDateFrom,
        params.offset,
        params.limit,
        params.sortBy,
        params.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    staleTime: MS_TIME.minute,
  });
